"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountries = void 0;
const api_1 = require("@/services/api");
const ENDPOINT = "/countries";
function getCountries() {
    const endpoint = `${ENDPOINT}`;
    return api_1.axiosInstance
        .get(endpoint)
        .then((response) => {
        return response.data.rows;
    })
        .catch((error) => {
        throw new Error(`[Countries Error]: ${error}`);
    });
}
exports.getCountries = getCountries;
